import { useRef } from 'react';
import { useGridFilter } from 'ag-grid-react';
import { Form } from 'antd';

import { createFilterComponent } from '../create-data-grid-filter';
import {
  createStringFilterModel,
  StringFilterModel,
  StringFilterParams,
} from './core';
import { StringFilterForm } from './string-filter.form';

export const StringFilterComponent = createFilterComponent<
  StringFilterModel,
  StringFilterParams
>(({ onModelChange, model, filterParams }) => {
  const { closeWhenChanged, filterName } = filterParams;
  const shouldClosePopupAfterChange = closeWhenChanged ?? true;
  const hidePopupRef = useRef<(() => void) | undefined>(() => {});
  const hidePopup = () => hidePopupRef.current?.();

  const [form] = Form.useForm();

  useGridFilter({
    // use for disable client-side filtering
    doesFilterPass: () => true,
    afterGuiAttached: (params) => {
      hidePopupRef.current = params?.hidePopup;
    },
  });

  const onSubmit = (value: string) => {
    const model = createStringFilterModel({
      value,
      filterName,
    });

    onModelChange(model);

    if (shouldClosePopupAfterChange) hidePopup();
  };

  const onReset = () => {
    form.resetFields();
    onModelChange(null);

    if (shouldClosePopupAfterChange) hidePopup();
  };

  return (
    <StringFilterForm
      form={form}
      value={model?.value}
      onSubmit={onSubmit}
      onReset={onReset}
    />
  );
});

export type StringFilterComponent = typeof StringFilterComponent;
